export const dl_insuranceConstants = {
  DL_INSURANCE_LIST_REQUEST: "DL_INSURANCE_LIST_REQUEST",
  DL_INSURANCE_LIST_SUCCESS: "DL_INSURANCE_LIST_SUCCESS",
  DL_INSURANCE_LIST_FAILURE: "DL_INSURANCE_LIST_FAILURE",

  DL_INSURANCE_ASSIGN_DEAL_NUMBER_REQUEST:
    "DL_INSURANCE_ASSIGN_DEAL_NUMBER_REQUEST",
  DL_INSURANCE_ASSIGN_DEAL_NUMBER_SUCCESS:
    "DL_INSURANCE_ASSIGN_DEAL_NUMBER_SUCCESS",
  DL_INSURANCE_ASSIGN_DEAL_NUMBER_FAILURE:
    "DL_INSURANCE_ASSIGN_DEAL_NUMBER_FAILURE",

  DL_INSURANCE_SELECT_SUBMISSION: "DL_INSURANCE_SELECT_SUBMISSION",

  DL_INSURANCE_UPDATE_DEAL_NUMBER_INPUT_FIELD: "DL_INSURANCE_UPDATE_DEAL_NUMBER_INPUT_FIELD",

  DL_INSURANCE_CLEAR_DEAL_NUMBER_REQUEST: "DL_INSURANCE_CLEAR_DEAL_NUMBER_REQUEST",
  DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_SUCCESS: "DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_SUCCESS",
  DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_FAILURE: "DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_FAILURE",

  DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_REQUEST: "DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_REQUEST",
  DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_SUCCESS:  "DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_SUCCESS",
  DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_FAILURE: "DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_FAILURE",

  DL_INSURANCE_CLEAR_DEAL_JACKET_SUCCESS: "DL_INSURANCE_CLEAR_DEAL_JACKET_SUCCESS",

  DL_INSURANCE_DISPLAY_ALERT_MESSAGE: "DL_INSURANCE_DISPLAY_ALERT_MESSAGE"
};
